import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rIstatistikSonuc_2, rValue } from '../../models/.catalog';

export default class YatirimAmacliGayrimenkulSayiApi extends ApiBase<
  pList,
  rValue<rIstatistikSonuc_2>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/YatirimAmacliGayrimenkulSayi',
      }),
      options
    );
  }
}
